import c from "react";
import * as o from "@radix-ui/react-select";
import { ChevronDown as N } from "@styled-icons/boxicons-regular";
import { useFormContext as C, useController as E } from "react-hook-form";
import d from "classnames";
import I from "next/dynamic";
import { trigger as y, hasErrorBorder as S, inputPlaceholder as x, content as b, viewport as w, item as B, itemIndicator as T, scrolldownButton as _ } from "./SelectionElement.css.js";
import { formInputElement as q, inputLabel as M, asteriskContainer as R, inputErrorMessage as V } from "./FormInputElement.css.js";
import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { Icon as m } from "../icon/Icon.js";
const j = I(() => import("@hookform/error-message").then((r) => r.ErrorMessage), {
  ssr: !1
});
function G({
  element: r,
  children: p,
  className: u,
  attributes: t
}) {
  const h = `input-${r.id}`, [i, f] = c.useState(void 0);
  c.useEffect(() => {
    !i && typeof document < "u" && f(document.getElementsByClassName("typedream content slate-root")[0]);
  }, []);
  const {
    control: v
  } = C() || {}, {
    field: l,
    fieldState: {
      isTouched: g
    },
    formState: {
      errors: s
    }
  } = E({
    name: r.name,
    control: v,
    rules: {
      required: r.required
    }
  });
  return /* @__PURE__ */ a("div", {
    ...r.customAttributes,
    ...t,
    className: d(u, q),
    children: [!r.is_label_hidden && /* @__PURE__ */ e("label", {
      htmlFor: h,
      className: M,
      contentEditable: !1,
      children: r.label
    }), /* @__PURE__ */ a(o.Root, {
      onValueChange: l.onChange,
      disabled: r.disabled,
      dir: t == null ? void 0 : t.ref,
      value: l.value,
      children: [/* @__PURE__ */ a(o.Trigger, {
        className: d(y, {
          [S]: g && !!s[r.name],
          [x]: !l.value
        }),
        children: [/* @__PURE__ */ e(o.Value, {
          placeholder: r.placeholder
        }), /* @__PURE__ */ e(o.Icon, {
          children: /* @__PURE__ */ e(m, {
            type: "bx",
            name: "chevron-down"
          })
        }), r.required && /* @__PURE__ */ e("div", {
          className: R,
          children: /* @__PURE__ */ e("span", {
            children: "*"
          })
        })]
      }), /* @__PURE__ */ e(o.Portal, {
        container: i,
        children: /* @__PURE__ */ a(o.Content, {
          className: b,
          children: [/* @__PURE__ */ e(o.ScrollUpButton, {}), /* @__PURE__ */ e(o.Viewport, {
            className: w,
            children: (r.options || []).map((n) => /* @__PURE__ */ a(o.Item, {
              value: n.value.toString(),
              className: B,
              children: [/* @__PURE__ */ e(o.ItemText, {
                children: n.label
              }), /* @__PURE__ */ e(o.ItemIndicator, {
                className: T,
                children: /* @__PURE__ */ e(m, {
                  type: "bx",
                  name: "check"
                })
              })]
            }, n.value))
          }), /* @__PURE__ */ e(o.ScrollDownButton, {
            className: _,
            children: /* @__PURE__ */ e(N, {
              size: 16
            })
          })]
        })
      })]
    }), /* @__PURE__ */ e(j, {
      errors: s,
      name: r.name,
      render: (n) => /* @__PURE__ */ e("div", {
        className: V,
        children: n.message
      })
    }), p]
  });
}
export {
  G as SelectionElement
};
